import { cn } from '../../utils';

export default function ErrorOrHelp({
    name,
    error,
    help,
}: {
    name: string;
    error?: string | string[];
    help?: string;
}) {
    const classes = cn('alli-mt-2 alli-h-5 alli-text-sm', {
        'alli-text-red-400': error,
        'alli-text-gray-700': !error && help,
    });

    if (Array.isArray(error) && error.length > 0) {
        return (
            <ul
                className="alli-list-inside alli-list-disc"
                id={`${name}${error ? '-error' : '-description'}`}>
                {error.map((err, index) => {
                    let spacing = '';
                    if (index > 0) {
                        spacing = 'alli-mt-1';
                    }
                    return (
                        <li
                            key={`${name}-error-${index}`}
                            className={cn(classes, spacing)}>
                            {err}
                        </li>
                    );
                })}
            </ul>
        );
    }
    return (
        <p
            id={`${name}${error ? '-error' : '-description'}`}
            className={classes}>
            {error ? error : help}
        </p>
    );
}
